import { useState } from 'react';
import Button from '../ui/Button';
import { useFriends } from '../../contexts/FriendsContext';

function FormSplitBill() {
  const { selectedFriend, dispatch } = useFriends();

  const [bill, setBill] = useState('');
  const [paidByUser, setPaidByUser] = useState('');
  const [whoIsPaying, setWhoIsPaying] = useState('user');

  const paidByFriend = bill ? bill - paidByUser : '';

  function handleSubmit(e) {
    e.preventDefault();

    if (!bill || !paidByUser) return;

    dispatch({
      type: 'splitBill',
      payload: whoIsPaying === 'user' ? paidByFriend : -paidByUser,
    });
  }

  return (
    <form className="form-split-bill" onSubmit={handleSubmit}>
      <h2>Split a bill with {selectedFriend.name}</h2>

      <label>💵 Bill Value</label>
      <input
        type="number"
        value={bill}
        onChange={e => setBill(Number(e.target.value))}
      />

      <label>👤 Your Expense</label>
      <input
        type="number"
        value={paidByUser}
        onChange={e =>
          setPaidByUser(
            Number(e.target.value) > bill ? paidByUser : Number(e.target.value),
          )
        }
      />

      <label>👥 {selectedFriend.name}'s Expense</label>
      <input type="number" disabled value={paidByFriend} />

      <label>🫰 Who is paying the bill</label>
      <select value={whoIsPaying} onChange={e => setWhoIsPaying(e.target.value)}>
        <option value="user">You</option>
        <option value="friend">{selectedFriend.name}</option>
      </select>

      <Button>Split Bill</Button>
    </form>
  );
}

export default FormSplitBill;
